<template>
  <div id="app">
    <keep-alive include='appframe'>
    <router-view></router-view>
     </keep-alive>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>
